/**
 * Constants for PaymentLinkDialog and related components
 */

// Screen states for the payment flow
export const SCREEN_STATE = {
  SELECT_PAYMENT_METHOD: 0,
  SELECT_SHARE_LINK_OPTIONS: 1,
  SUCCESS_WITH_GENERATED_LINK: 2,
  SUCCESS_TOTAL_PAYMENT_WITH_WALLET: 3,
  ERROR_CREATING_APPOINTMENT: 4,
  APPOINTMENT_CREATED_BUT_LINK_NOT_GENERATED: 5,
};

// Payment method options
export const PAYMENT_METHOD = {
  WALLET_AND_RAZORPAY: 1, // Partial wallet payment + Razorpay for remaining
  RAZORPAY_ONLY: 2, // Full payment via Razorpay
  WALLET_ONLY: 3, // Full payment via wallet
  WALLET_DISABLED: 4, // Wallet option shown but disabled (wallet empty)
};
